import React from 'react';
import { useWatch } from 'react-hook-form';

import { ProveYourHumanity } from '#components/Tasks/components/ProveYourHumanity';

export const ProveYourHumanityPreview = ({ index }: { index: number }) => {
  const task = useWatch({
    name: `tasks.${index}`,
  });

  return <ProveYourHumanity task={task} preview={true} />;
};
